import { useEffect } from "react";
import { useBartlettContext } from "../contexts/BartlettContext";

const useBartlett = (id: string, username: string, password: string, datestamp: number = 0) => {
  const { fetchBartlettKiln, kilns } = useBartlettContext();

  useEffect(() => {
    if (id && username) {
      fetchBartlettKiln(id, username, password);
    }
  }, [id, username, password, datestamp, fetchBartlettKiln]);

  return kilns?.[id];
};

export default useBartlett;
